import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  generate() {
    const password = this.generatePassword(8)
    const passwordField = document.getElementById("password_field")
    if (passwordField) {
      passwordField.value = password
    }
  }

  copy() {
    const passwordField = document.getElementById("password_field")
    if (passwordField && passwordField.value) {
      navigator.clipboard.writeText(passwordField.value).then(() => {
        // Показываем успешное уведомление
        this.showToast("Пароль скопирован в буфер обмена")
      }).catch(err => {
        console.error('Ошибка копирования: ', err)
        this.showToast("Ошибка копирования пароля", "danger")
      })
    } else {
      this.showToast("Нет пароля для копирования", "warning")
    }
  }

  generatePassword(length) {
    const charset = "0123456789"
    let password = ""
    for (let i = 0; i < length; i++) {
      password += charset.charAt(Math.floor(Math.random() * charset.length))
    }
    return password
  }

  showToast(message, type = "success") {
    // Создаем временный toast
    const toastHtml = `
      <div class="toast align-items-center text-white bg-${type} border-0" role="alert" aria-live="assertive" aria-atomic="true">
        <div class="d-flex">
          <div class="toast-body">
            ${message}
          </div>
          <button type="button" class="btn-close btn-close-white me-2 m-auto" data-bs-dismiss="toast" aria-label="Close"></button>
        </div>
      </div>
    `
    
    // Находим или создаем контейнер для toast
    let toastContainer = document.querySelector('.toast-container')
    if (!toastContainer) {
      toastContainer = document.createElement('div')
      toastContainer.className = 'toast-container position-fixed top-0 end-0 p-3'
      document.body.appendChild(toastContainer)
    }
    
    // Добавляем toast
    toastContainer.insertAdjacentHTML('beforeend', toastHtml)
    
    // Показываем toast
    const toastElement = toastContainer.lastElementChild
    const toast = new bootstrap.Toast(toastElement)
    toast.show()
    
    // Удаляем toast после скрытия
    toastElement.addEventListener('hidden.bs.toast', () => {
      toastElement.remove()
    })
  }
}
